import React, {
  Component,
  MouseEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useStore } from "../store";
import Card from "react-bootstrap/Card";
import { Colors } from "../utils/style";
import { Light, Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import {
  darcula,
  dark,
  solarizedlight,
} from "react-syntax-highlighter/dist/esm/styles/prism";
import {
  github,
  stackoverflowDark,
} from "react-syntax-highlighter/dist/cjs/styles/hljs";
import { stackoverflowLight } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { vs } from "react-syntax-highlighter/dist/esm/styles/prism";
import { duotoneDark } from "react-syntax-highlighter/dist/esm/styles/prism";

type Prop = {
  title?: string;
  code?: string | null;
};

function CardComponent(props: Prop) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        color: Colors.DARK_GRAY,
        height: "100%",
      }}
    >
      <Card
        style={{
          backgroundColor: "#e5e4e2",
          width: "100%",
          height: "100%",
        }}
      >
        <Card.Body
          className="text-center"
          style={{
            color: Colors.DARK_GRAY,
          }}
        >
          <>
            {props.title && (
              <Card.Title
                style={{
                  textAlign: "center",
                  fontSize: "15px",
                }}
              >
                {props.title}
              </Card.Title>
            )}
            {props.code && (
              <div style={{ width: "100%" }}>
                <SyntaxHighlighter language="python" style={darcula}>
                  {props.code}
                </SyntaxHighlighter>
              </div>
            )}
          </>
        </Card.Body>
      </Card>
    </div>
  );
}

export default CardComponent;
